import React from 'react';
import { LeftMenuItem } from '../shared/LeftMenuItem';
import { NotificationFlagsCategories } from '../../../../models/NotificationFlags/NotificationFlagsCategories';

export const EcosystemHomepageMenuItem = () => (
    <LeftMenuItem
        icon="pe-7s-display2"
        label="Ecosystem Homepage"
        to="/user-home"
        flagCode={NotificationFlagsCategories.AnnouncementsCode}
        trackingAction="Home"
        gtmCategory="Home"
    />
);
